export default class DesktopMenu {
    constructor($el) {
        this.$el = $el;
        this.$childMenuTriggers = this.$el.querySelectorAll('[data-open-child-menu]');

        this.openChildMenu = this.openChildMenu.bind(this);

        this.$childMenuTriggers.forEach($trigger => $trigger.addEventListener('mouseover', this.openChildMenu));
        this.$childMenuTriggers.forEach($trigger => $trigger.addEventListener('mouseleave', this.closeChildMenu));
    }

    /**
     * Open child menu
     * @param e
     */
    openChildMenu(e) {
        const $item = e.target.closest('[data-open-child-menu]')
        const $link = $item.querySelector('[data-menu-link]');
        const $menu = $item.querySelector('[data-child-menu]');
        $link.classList.add('highlighted');
        $link.setAttribute('aria-expanded', true);
        $menu.style.display = 'block';
        $menu.setAttribute('aria-hidden', false);
    }

    /**
     * Close child menu
     * @param e
     */
    closeChildMenu(e) {
        const $item = e.target.closest('[data-open-child-menu]');
        const $link = $item.querySelector('[data-menu-link]');
        const $menu = $item.querySelector('[data-child-menu]');
        $link.classList.remove('highlighted');
        $link.setAttribute('aria-expanded', false);
        $menu.setAttribute('aria-hidden', true);
        $menu.style.display = 'none';
    }
}